import { render } from "./Product.vue?vue&type=template&id=a41c1e92&scoped=true&ts=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"

import "./Product.vue?vue&type=style&index=0&id=a41c1e92&scoped=true&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a41c1e92"]])

export default __exports__